

export const addSurgeryDates = (surgeryDates, visibleDateRange) => {
    let datesInString = [];
    const currentDatesInView = Array.prototype.filter.call(
        document.getElementsByTagName('td'),
        function (testElement) {
            return testElement.firstChild.className !== 'p-disabled';
        }
    );
    for (let surgeryDate in surgeryDates) {
        if (
            surgeryDates[surgeryDate] >= new Date(visibleDateRange[0].setHours(0, 0, 0, 0)) &&
            surgeryDates[surgeryDate] <= new Date(visibleDateRange[1].setHours(23, 59, 59, 59))
        ) {
            datesInString.push(surgeryDates[surgeryDate].getDate().toString());
        }
    }
    for (let dates in currentDatesInView) {
        if (
            datesInString.includes(
                currentDatesInView[dates].getElementsByTagName('span')[0]?.innerHTML
            )
        ) {
            let node = document.createElement('div');
            node.className = 'pixieDust';
            currentDatesInView[dates].firstChild.appendChild(node);
        }
    }
};

export const removeSurgeryDates = () => {
    document.querySelectorAll('.pixieDust').forEach((pixieDustElement) => pixieDustElement.remove());
};
